import { getCybsTheme, ICybsTheme } from './cybs';
import { getSkinVariables, ISkinVariables } from './skin';
import { getStructureVariables, IStructureVariables } from './structure';
import { getThemeVariables, IThemeVariables } from './themeVariables';
import {
  getGlobalTypography,
  getTypographyVariables,
  ITypographyVariables
} from './typography';
import { getUtilityVariables, IUtilityVariables } from './utilities';

interface ICoreThemeOptions {
  primary?: string;
  secondary?: string;
  tertiary?: string;
  link?: string;

  // Legacy API for changing link color
  // TODO: remove legacy support in a future major release
  linkColor?: string;
}

interface IComponentThemeOptions {
  footer?: {
    background?: string;
    link?: string;
    text?: string;
  };
  navbar?: {
    background?: string;
    foreground?: string;
    backgroundSelected?: string;
    indicatorBar?: string;
    dropdownSelected?: string;
    rollover?: string;
  };
  topbar?: {
    background?: string;
    foreground?: string;
    partnerLink?: string;
    portalText?: string;
  };
}

export interface IThemeOptions {
  accessible?: boolean;

  // Legacy API for changing link color
  // TODO: remove legacy support in a future major release
  isSwatch?: ICoreThemeOptions;

  core?: ICoreThemeOptions;
  component?: IComponentThemeOptions;
}

interface ITheme {
  classes: {
    skin: ISkinVariables;
    structure: IStructureVariables;
    typography: ITypographyVariables;
    utilities: IUtilityVariables;
  };
  cybs: ICybsTheme;
  global: {
    type: object;
  };
  variables: IThemeVariables;
  vds: object;
}

/**
 * Builds a new object based to be used for theming frontend applications
 * @param {object} themeOptions - optional theme color customizations
 * @returns {object}
 */
const themeBuilder = (themeOptions: IThemeOptions = {}): ITheme => {
  const themeVariables: IThemeVariables = getThemeVariables(themeOptions);
  const theme = {
    // CSS delcarations using Emotion
    classes: {
      skin: getSkinVariables(themeVariables),
      structure: getStructureVariables(themeVariables),
      typography: getTypographyVariables(themeVariables),
      utilities: getUtilityVariables(themeVariables)
    },
    // Simplified theme to be used by Cybs components
    // Eventually it would be nice to scrap the rest of the theme in favor of this part
    cybs: getCybsTheme(themeVariables),
    // Global CSS rules
    global: {
      type: getGlobalTypography(themeVariables)
    },
    // All theme variables plus semantically nested variables
    variables: themeVariables,
    // All theme variables
    vds: themeVariables.CSS_VARS
  };

  return theme;
};

export default themeBuilder;
